import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlipCardComponent } from './flip-card.component';
import { FlipCardFrontComponent } from './flip-card-front';
import { FlipCardBackComponent } from './flip-card-back';
import { MaterialGlobalModule } from 'src/app/shared/modules/material-global.module';


@NgModule({
  imports: [
    CommonModule,
    MaterialGlobalModule
  ],
  declarations: [FlipCardComponent, FlipCardFrontComponent, FlipCardBackComponent],
  exports: [FlipCardComponent, FlipCardFrontComponent, FlipCardBackComponent]
})
export class FlipCardModule { }
